import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const variants: Record<string, string> = {
  DRAFT: "bg-slate-100/80 text-slate-700 border-slate-200",
  SENT: "bg-blue-50/80 text-blue-700 border-blue-200",
  PAID: "bg-emerald-50/80 text-emerald-700 border-emerald-200",
  OVERDUE: "bg-amber-50/80 text-amber-700 border-amber-200",
  CREDIT: "bg-purple-50/80 text-purple-700 border-purple-200",
  ACCEPTED: "bg-emerald-50/80 text-emerald-700 border-emerald-200",
  REJECTED: "bg-rose-50/80 text-rose-700 border-rose-200",
  INVOICED: "bg-brand-50/80 text-brand-700 border-brand-200",
  default: "bg-slate-100/80 text-slate-700 border-slate-200",
};

export function Badge({
  children,
  status,
  className,
  pulse = false,
}: {
  children: React.ReactNode;
  status?: string;
  className?: string;
  pulse?: boolean;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border backdrop-blur-sm",
        variants[status || "default"],
        pulse && "animate-pulse",
        className
      )}
    >
      {children}
    </span>
  );
}
